export default __webpack_public_path__ + "static/media/discord.c93a6d20.svg";